let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lpvO9")).then(() => parcelRequire('4Uks5'));